module.exports = "pegasus/assets/hexline-instagram.png";